import logic from "src/utils/genLogic";
import { ActionTypes } from "./actions";
import { push } from "connected-react-router";
import { Trans } from "@lingui/react";

const apiNamespace = "Customers";

const getAllCustomersLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_CUSTOMERS,
});

const getCustomerWithIdLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_CUSTOMER_WITH_ID,
});

const addCustomerLogic = logic(apiNamespace, {
  actionName: ActionTypes.ADD_CUSTOMER,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_added_successfully" />,
  successCb: (dispatch) => {
    dispatch(push("/customers/list"));
  },
});

const editCustomerLogic = logic(apiNamespace, {
  actionName: ActionTypes.EDIT_CUSTOMER,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_edited_successfully" />,
  successCb: (dispatch) => {
    dispatch(push("/customers/list"));
  },
});

const deleteCustomerLogic = logic(apiNamespace, {
  actionName: ActionTypes.DELETE_CUSTOMER,
  showErrorMessage: true,
  errorMessage: <Trans id="there_is_an_error_occurred_try_again_later" />,
  showSuccessMessage: true,
  successMessage: <Trans id="item_deleted_successfully" />,
});

export default [
  getAllCustomersLogic,
  getCustomerWithIdLogic,
  addCustomerLogic,
  editCustomerLogic,
  deleteCustomerLogic,
];
